<template>
  <div class="lcu-secondary-nav" :class="{
      'lcu-secondary-navISO': _device.iPhone && _device.app,
    }">
    <div class="lcu-nav-wrap">
      <div class="lcu-secondary-inner" :class="{
        'lcu-secondary-menuOpen': openMobileMenu
      }">
        <div class="lcu-secondary-left">
          <router-link to="/">
            <img
              class="lcu-secondary-navLogo"
              src="/assets/lcu-logo-blue-wide.svg"
              alt="LCU Dashboard Logo" />
          </router-link>
        </div>
        <div class="lcu-secondary-right">
          <router-link
            to="/"
            :class="{
              'lcu-secondary-linkTextActive': $router.currentRoute.value.path === '/',
            }"
            class="lcu-secondary-link">
            <span class="lcu-secondary-linkText">
              Inicio
            </span>
          </router-link>
          <router-link
            to="/acerca-de-lcu"
            :class="{
              'lcu-secondary-linkTextActive':
                $router.currentRoute.value.path.match(/^\/acerca-de-lcu/gi),
            }"
            class="lcu-secondary-link">
            <span class="lcu-secondary-linkText">
              Acerca de LCU
            </span>
          </router-link>
          <router-link
            to="/admisiones"
            :class="{
              'lcu-secondary-linkTextActive':
                $router.currentRoute.value.path.match(/^\/admisiones/gi),
            }"
            class="lcu-secondary-link">
            <span class="lcu-secondary-linkText">
              Admisiones
            </span>
          </router-link>
          <router-link
            to="/plan-de-estudios"
            :class="{
              'lcu-secondary-linkTextActive':
                $router.currentRoute.value.path.match(/^\/plan-de-estudios/gi),
            }"
            class="lcu-secondary-link">
            <span class="lcu-secondary-linkText">
              Plan de Estudios
            </span>
          </router-link>
          <router-link
            to="/patrocinar-estudiante"
            :class="{
              'lcu-secondary-linkTextActive':
                $router.currentRoute.value.path.match(/^\/patrocinar-estudiante/gi),
            }"
            class="lcu-secondary-link">
            <span class="lcu-secondary-linkText">
              Patrocinar Estudiante
            </span>
          </router-link>
        </div>
        <div class="lcu-secondary-mobile">
          <button
            class="lcu-secondary-mobileBtn"
            :class="{
              'lcu-secondary-mobileBtnOpen': openMobileMenu,
            }"
            @click.prevent="openMobileMenu = !openMobileMenu"
            aria-label="Mobile menu" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'secondary-nav',
  components: {
  },
  computed: {
    ...mapGetters(['user', 'userLoading']),
  },
  data() {
    return {
      loginModal: false,
      openMobileMenu: false,
    };
  },
  methods: {
    checkLink(path) {
      this.$router.push({ path });
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-secondary-nav {
  align-items: center;
  background-color: $white;
  border-bottom: 1px solid $page-border;
  color: $legacy-primary;
  display: flex;
  height: 85px;
  justify-content: center;
  position: relative;
  transition-duration: .2s;
  width: 100%;
  z-index: 4;

  @media only screen and (max-width: $mobile-max) {
    border-right: none;
    border-top: 1px solid rgba($white, .2);
    bottom: 0;
    height: 70px;
    padding: 0;
    width: 100%;
  }

  @media print {
    display: none;
  }
}

.lcu-nav-wrap {
  max-width: 1280px;
  position: relative;
  width: 90%;
  height: 100%;

  @media only screen and (max-width: $mobile-max) {
    width: 100%;
  }
}

.lcu-secondary-inner {
  display: grid;
  grid-gap: 5px;
  grid-template-columns: min-content 1fr;
  grid-template-rows: auto;
  padding: 0;
  width: 100%;
  height: 100%;

  @media only screen and (max-width: $mobile-max) {
    padding: 0 20px;
  }
}

.lcu-secondary-navISO {

  .lcu-nav-wrap {
    top: -5px;

    @include ipad-pro-12 {
      top: 0;
    }
  }

  @media only screen and (max-width: $mobile-max) {
    height: 80px;
  }

  @include ipad-pro-12 {
    top: 25px;
  }
}

.lcu-secondary-mobileBtn {
  border: 1px solid $page-border;
  background-color: transparent;
  padding: 10px;
  border-radius: 3px;

  &:after {
    content: '\e810';
    font-family: 'lcu';
    color: $legacy-primary;
  }
}

.lcu-secondary-mobileBtnOpen {
    &:after {
    content: '\e811';
  }
}

.lcu-secondary-left {
  align-items: center;
  display: flex;
  justify-content: flex-start;

  @media only screen and (max-width: $tablet-max) {
    // display: none;
  }
}

.lcu-secondary-right {
  align-items: center;
  display: flex;
  justify-content: flex-end;

  @media only screen and (max-width: $tablet-max) {
    display: none;
  }
}

.lcu-secondary-menuOpen {
  .lcu-secondary-right {
    @media only screen and (max-width: $tablet-max) {
      display: flex;
      position: absolute;
      width: 100%;
      background-color: $white;
      top: 85px;
      flex-direction: column;
      border-left: 1px solid $page-border;
      border-right: 1px solid $page-border;
      border-bottom: 1px solid $page-border;
      left: 0;
    }
    @media only screen and (max-width: $mobile-max) {
      top: 69px;
    }
  }
  .lcu-secondary-link {
    @media only screen and (max-width: $tablet-max) {
      display: block;
      padding: 20px 30px;
      margin-right: 0;
      width: 100%;
      border-bottom: 1px solid $off-white;

      &:last-child {
        border-bottom: none;
      }
    }
  }
}

.lcu-secondary-mobile {
  display: none;
  align-items: center;
  justify-content: flex-end;

  @media only screen and (max-width: $tablet-max) {
    display: flex;
  }
}

.lcu-secondary-navLogo {
  width: 120px;
}

.lcu-secondary-links {
  padding-top: 50px;

  @media only screen and (max-width: $mobile-max) {
    align-items: center;
    border-top: 1px solid rgba($white, .2);
    display: flex;
    justify-content: space-between;
    padding: 9px 20px 3px;
  }
}

.lcu-secondary-linksISO {

  @media only screen and (max-width: $mobile-max) {
    padding: 10px 20px 5px;
  }
}

.lcu-secondary-linkText {
  border-bottom: 3px solid transparent;
  padding-bottom: 5px;
  transition-duration: .2s;
}

.lcu-secondary-link {
  color: $legacy-primary;
  display: inline-flex;
  margin-right: 25px;
  overflow: hidden;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 100%;
  align-items: center;
  padding: 5px 15px 0;

  &:hover {
    .lcu-secondary-linkText {
      border-bottom-color: $legacy-secondary;
    }
  }

  &:last-child {
    margin-bottom: 0;
    margin-right: 0;
  }
}

.lcu-secondary-linkTextActive {

  .lcu-secondary-linkText {
    border-bottom-color: $legacy-secondary;
  }
}

.lcu-secondary-active {
  color: $white;
  font-weight: bold;

  &:before {
    color: $legacy-secondary;
  }
}
</style>
